module.exports = __webpack_public_path__ + "img/合作伙伴背景.9ade0dff.png";